import axios from "axios";
// Send Mail to all Users
export const notifysubscribers = async (Subject, title, description) => {
    try {
        const response = await axios.post("/api/v1/subscriber/notify", {
            subject: Subject,
            message: `
                <p>${description}</p>
                <br/>
                <h5>To Read More Please visit the website</h5><a href="http://localhost:3000/blogs">Practical Pet Parenting</a>
                `
        });
    } catch (err) {
        console.log(err);
    }
};